import React from "react";
import PropTypes from "prop-types";

const SHIMMER = {
  background: "linear-gradient(90deg, #F3F4F6 25%, #E5E7EB 50%, #F3F4F6 75%)",
  backgroundSize: "200% 100%",
  animation: "t2t-shimmer 1.4s infinite",
  borderRadius: 4,
  display: "inline-block",
};

SkeletonRow.propTypes = { cols: PropTypes.arrayOf(PropTypes.string) };

export default function SkeletonRow({ cols }) {
  return (
    <tr style={{ opacity: 0.85 }}>
      {/* checkbox */}
      <td style={{ width: 36, padding: "10px 12px" }}>
        <span style={{ ...SHIMMER, width: 16, height: 16, borderRadius: 3 }} />
      </td>
      {(cols || []).map((col, i) => (
        <td key={col} style={{ padding: "10px 12px" }}>
          <span style={{ ...SHIMMER, width: i === 0 ? 60 : i === 1 ? "70%" : "50%", height: 12 }} />
        </td>
      ))}
    </tr>
  );
}
